import { localStorageKeys } from "app-config";
import type User from "models/User";

/**
 * Enregistre dans le localStorage les données de l'utilisateur passé
 * en paramètre.
 * @param userInfo User à enregistrer dans le localStorage.
 */
function updateStorageUser(userInfo: User): void {
  localStorage.setItem(localStorageKeys.currentUserData, JSON.stringify(userInfo));
  window.dispatchEvent(new Event("storage"));
}

/**
 * Supprime du localStorage les données du compte actuellement identifié.
 */
function removeUserInfo(): void {
  localStorage.removeItem(localStorageKeys.currentUserData);
  window.dispatchEvent(new Event("storage"));
}

/**
 * Supprime toutes les données du sessionStorage et les données du localStorage liées à l'authentificaiton
 * puis recharge la page; permet d'éviter les conflits de token de rafraichissement.
 */
function clearLocalAndSessionStorage(): void {
  // eslint-disable-next-line no-console
  console.info("%cCLEANING LOCAL AND SESSION STORAGE", "color: cornflowerblue;");

  // Cleanup offline user info from localStorage
  removeUserInfo();

  // Remember sdeapps.* keys in localStorage
  const SDEAppsLocalStorageToKeep: Record<string, string | null> = {};
  for (const key of Object.keys(localStorage)) {
    if (key.toLowerCase().startsWith("sdeapps")) {
      SDEAppsLocalStorageToKeep[key] = localStorage.getItem(key);
    }
  }

  // Clear entire localStorage
  localStorage.clear();

  // Restore sdeapps.* keys
  for (const [key, value] of Object.entries(SDEAppsLocalStorageToKeep)) {
    if (value != null) {
      localStorage.setItem(key, value);
    }
  }

  // Clear entire sessionStorage
  sessionStorage.clear();
}

const storageService = {
  updateStorageUser,
  removeUserInfo,
  clearLocalAndSessionStorage,
};
export default storageService;
